export const FEATURE_FLAGS = {
  // Toggle to bring /tracking and /tracking/dfans back online.
  dashboardTracking: false,
  // Toggle to bring the client calendar back online.
  dashboardCalendar: true,
  // Toggle to bring the client compass back online.
  dashboardCompass: false,
} as const;
